import { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'

export function formatSecondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60

    const formattedTime = `${padZero(hours)}:${padZero(minutes)}`
    return formattedTime
}

function padZero(number) {
    return String(number).padStart(2, '0')
}
